const lazy = path => () => import(`./${path}`);

// 领取
export default [
  // 日结审核详情
  {
    path: "/wageSlip",
    name: "wageSlip",
    component: lazy("index"),
    meta: {
      title: "我的工资单",
      keepAlive: true
    },
  },
  {
    path: '/wageSlip/detail',
    name: 'wageSlipDetail',
    component: lazy("detail"),
    meta: {
      title: "工资单",
      keepAlive: false
    },
  },
  {
    path: '/wageSlip/desc',
    name: 'wageSlipDesc',
    component: lazy("desc"),
    meta: {
      title: "说明详情",
      keepAlive: false
    },
  },
  {
    path: '/wageSlip/feedback',
    name: 'WageSlipFeedback',
    component: lazy("feedback"),
    meta: {
      title: "我要反馈",
      keepAlive: false
    },
  },
  {
    path: '/wageSlip/sign',
    name: 'WageSlipSign',
    component: lazy("sign"),
    meta: {
      title: "签字确认",
      keepAlive: false
    },
  }

];
